import type { TutorAttendanceRatesStore } from './interfaces'

import { emptyTutorAttendanceRatesFilters } from '../../lib/tutor-attendance-rates-query'

export const actions = {
  setLoading (this: TutorAttendanceRatesStore, payload: TutorAttendanceRatesStore['loading']): void {
    this.loading = payload
  },
  setRates (this: TutorAttendanceRatesStore, payload: TutorAttendanceRatesStore['rates']): void {
    this.rates = payload
  },
  setTotals (this: TutorAttendanceRatesStore, payload: TutorAttendanceRatesStore['totals']): void {
    this.totals = payload
  },
  setMeta (this: TutorAttendanceRatesStore, payload: TutorAttendanceRatesStore['meta']): void {
    this.meta = payload
  },
  setFilters (this: TutorAttendanceRatesStore, payload: TutorAttendanceRatesStore['filters']): void {
    this.filters = payload
  },
  setFilterTutorIds (this: TutorAttendanceRatesStore, payload: TutorAttendanceRatesStore['filters']['tutorIds']): void {
    this.filters.tutorIds = payload
  },
  setFilterStatuses (this: TutorAttendanceRatesStore, payload: TutorAttendanceRatesStore['filters']['statuses']): void {
    this.filters.statuses = payload
  },
  setFilterReasons (this: TutorAttendanceRatesStore, payload: TutorAttendanceRatesStore['filters']['reasons']): void {
    this.filters.reasons = payload
  },
  setFilterDates (this: TutorAttendanceRatesStore, payload: Pick<TutorAttendanceRatesStore['filters'], 'from' | 'to'>): void {
    this.filters.from = payload.from
    this.filters.to = payload.to
  },
  setCurrentPage (this: TutorAttendanceRatesStore, payload: TutorAttendanceRatesStore['currentPage']): void {
    this.currentPage = payload
  },
  setPerPage (this: TutorAttendanceRatesStore, payload: TutorAttendanceRatesStore['perPage']): void {
    this.perPage = payload
  },
  resetFilters (this: TutorAttendanceRatesStore): void {
    this.filters = emptyTutorAttendanceRatesFilters()
    this.currentPage = 1
  },
}
